import { useCallback } from 'react';

import { useActor, useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';
import { AuthModel } from '../AuthMachine.model';

// ─────────────────────────────────────────────────────────────────────────────

export const usePostLoginRedirectHref = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.postLoginRedirectHref);
};

export const useSendClearPostLoginRedirectHref = () => {
  const { authMachineRef } = useEssentialMachines();

  const [, send] = useActor(authMachineRef);

  return useCallback(() => {
    send(AuthModel.events.CLEAR_POST_LOGIN_REDIRECT_HREF());
  }, [send]);
};
